// components/ui/LuxuryCard.jsx
import React from 'react';
import { motion } from 'framer-motion';

const LuxuryCard = ({
                        children,
                        className = '',
                        hoverable = true,
                        glow = false,
                        border = true,
                        ...props
                    }) => {
    return (
        <motion.div
            whileHover={hoverable ? { y: -8 } : {}}
            className={`
        bg-gradient-to-br from-white via-pearl-white to-soft-ivory 
        rounded-3xl shadow-soft hover:shadow-lift transition-all duration-500
        ${border ? 'border border-nude-beige/30' : ''}
        ${glow ? 'relative' : ''}
        ${className}
      `}
            {...props}
        >
            {glow && (
                <motion.div
                    className="absolute inset-0 bg-gradient-to-br from-champagne-gold/5 to-transparent rounded-3xl -z-10 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                />
            )}
            {children}
        </motion.div>
    );
};

export default LuxuryCard;